<template>
  <div
    :class="$style.paymentStatus"
  >
    <div
      :class="[$style.circle, color]"
    />

    <div :class="$style.text">
      {{ status }}
    </div>

  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PollsStatuses, PollsStatusesTranslate } from '@/enums';

@Component({
  components: {
    PartiallyPayment: () => import('@/assets/icons/partially-payment.svg?inline'),
  },
})
export default class PollStatus extends Vue {
  @Prop({ type: String, default: '' })
  poll_status!: PollsStatuses;

  get color() {
    switch (this.poll_status) {
      case PollsStatuses.NOT_COMPLETED:
        return 'yellow';

      case PollsStatuses.NEW:
        return 'blue';

      default:
        return 'green';
    }
  }

  get status() {
    return PollsStatusesTranslate[this.poll_status] || '';
  }
}
</script>

<style module lang="scss">
.paymentStatus {
  display: flex;
  align-items: center;
}

.icon {
  width: 8px;
  height: 8px;
  color: $secondary_darken4;
  margin-right: 10px;
}

.circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;

  &:global(.yellow) {
    background-color: #F2EB50;
  }

  &:global(.green) {
    background-color: $success_darken4;
  }

  &:global(.blue) {
    background-color: $accent_darken4;
  }
}

.text {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
